import React, { useEffect, useRef, useState } from "react";
import founder1 from '../images/founder1.avif';
import founder2 from '../images/founder2.avif';
import './profile.css';

const Founders = () => {
  const [isAnimated, setIsAnimated] = useState(false);
  const [hoveredFounder, setHoveredFounder] = useState(null); // To keep track of the hovered founder
  const observerRef = useRef(null);
  const isComponentMounted = useRef(true); // Cleanup flag

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Trigger the animation when at least 50% of the element is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsAnimated(true);
        }
      });
    }, options);

    observer.observe(observerRef.current);

    return () => {
      isComponentMounted.current = false; // Set the flag to false when unmounting

      // Check if the observer is present before unobserving
      if (observerRef.current) {
        observer.unobserve(observerRef.current); // Call unobserve inside the cleanup function
      }
    };
  }, []);


  // Helper function to handle hovering on founder images
  const handleHover = (founder) => {
    setHoveredFounder(founder);
  };

  // Helper function to reset hoveredFounder when mouse leaves the image
  const handleMouseLeave = () => {
    setHoveredFounder(null);
  };

  return (
    <>
    <div className="founders-container">
      <div className="intro">
        <h1 className="greeting">
          Hey! 👋🏻 <br />
          We are Oh Studio.
        </h1>
      </div>
      <div className={`founders ${isAnimated ? "animate-founders" : ""}`} ref={observerRef}>
        <div
          className={`founder left`}
          onMouseOver={() => handleHover("Founder 1")}
          onMouseLeave={handleMouseLeave}
        >
          <img src={founder1} alt="Founder 1" className={hoveredFounder === "Founder 1" ? "blur" : ""} />
          {hoveredFounder === "Founder 1" && (
            <div className="founder-name">
                Jimmy Choo
                </div>
          )}
        </div>
        <div
          className={`founder right`}
          onMouseOver={() => handleHover("Founder 2")}
          onMouseLeave={handleMouseLeave}
        >
          <img src={founder2} alt="Founder 2" className={hoveredFounder === "Founder 2" ? "blur" : ""} />
          {hoveredFounder === "Founder 2" && (
            <div className="founder-name">Walter White</div>
          )}
        </div>
      </div>
        <div className="founder-intro">
          <h2>
          Meet Our Founders!
          </h2>
        </div>
      </div>
    </>
  );
};

export default Founders;
